//[ null, 'Electronic', 'Hardback', 'Paperback', 'Set' ]
export enum ProductSupplyFormat {
  Electronic = "Electronic",
  Hardback = "Hardback",
  Paperback = "Paperback",
  Set = "Set",
}
